module.exports = __webpack_public_path__ + "img/xiaocx.ae637565.jpg";